import React, { useEffect, useState } from "react";
import { Avatar, Typography, Box, Tooltip } from "@mui/material";
import { SVG_CHEVRON_DOWN, SVG_CHEVRON_UP } from "../../Assets/SVG/svg_util";
import useMediaQuery from "@mui/material/useMediaQuery";

const formattedDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
};

const ExpandableCard = ({ row, columns }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const getColumnValue = (columnId) => row[columnId] || "N/A";

  const getColumnsByType = (type) =>
    columns.filter((column) => column.id.toLowerCase().includes(type));

  const renderColumns = (type) => {
    const columnsOfType = getColumnsByType(type);
    return columnsOfType.map((column, index) => {
      const value =
        type === "date"
          ? formattedDate(getColumnValue(column.id))
          : getColumnValue(column.id);
      return (
        <span key={column.id}>

{type === "date" ? (
    <>
      <strong>{column.label}</strong>: {value}
    </>
  ) : (
    value
  )}
          
        </span>
      );
    });
  };
  

  const avatarInitial = () => {
    const nameColumn = getColumnsByType("name")[0];
    return nameColumn
      ? getColumnValue(nameColumn.id).charAt(0).toUpperCase()
      : null;
  };

  useEffect(() => {
    const nameColumn = getColumnsByType("name")[0];
    if (!nameColumn) setExpanded(true);
  }, [expanded]);

  return (
    <div className="bg-gray-100  p-2 rounded-md border opacity-80 cursor-pointer ">
      {/* flex  justify-between items-center    flex gap-4 items-center text-left     flex flex-col flex-wrap flex flex-wrap gap-2*/}
      {avatarInitial() && (
        <div className="flex items-center mb-2">
          
            <Avatar
              sx={{ bgcolor: "primary.main" }}
              className="float-left mr-2"
            >
              {avatarInitial()}
            </Avatar>
        
              
      
        <Tooltip title={renderColumns("name")} enterTouchDelay={0}>
                <Typography
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    paddingRight: "20px",
                  }}
                >
                  {renderColumns("name")}
                </Typography>
              </Tooltip>
          
          
             {/* {renderColumns("date") && <div> {renderColumns("date")[0]}</div>} */}
        
         
        
              <div onClick={handleExpandClick} className="ml-auto">
              {expanded ? <SVG_CHEVRON_UP /> : <SVG_CHEVRON_DOWN />}
            </div>
            
         
        </div>
      )}

      {expanded && (
        <div className="text-left grid grid-cols-1 sm:grid-cols-2  rounded-lg ">
          {columns.map((column) => {
            const value = row[column.id];
            return (
              <div key={column.id} className="border p-3 bg-gray-300 ">
                <Typography variant="body2" color="text.secondary">
                  {column.label}
                </Typography>
                <Typography
                  variant="body2"
                  className="flex flex-wrap flex-col"
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    minWidth: "100px",
                  }}
                >
                  {column?.renderCell
                    ? column.renderCell(row)
                    : value
                    ? value
                    : value == 0
                    ? value
                    : "N/A"}
                </Typography>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default function TableCard({ columns, data }) {
  return (
    <Box sx={{ maxWidth: "xl", mx: "auto", p: 2, display:"flex",
  flexDirection:"column",gap:2 }}>
      {data?.map((row, rowIndex) => (
        <ExpandableCard key={rowIndex} row={row} columns={columns} />
      ))}
    </Box>
  );
}
